import { render } from "./Footer.vue?vue&type=template&id=0cf18d78"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=0cf18d78&lang=scss"

import exportComponent from "D:\\Server\\Projects\\aurus-applications-support\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__